module.exports = __webpack_public_path__ + "img/300_25.b5bc9ee9.jpg";